type FeatureFlag = "video" | "song" | "exportcsv" | "betting";
export const getFeatureFlag = (key: FeatureFlag) => new URLSearchParams(window.location.search).get(key);
